import variables from "../variables";
import { links } from "../../Utils";
import wife from "./wife";
import {jumpTo} from "../../Utils";
import Man from "./Man";
import images from "../images";
import places from "../places/places";

const player = new Man(
    "player",
    variables.player.name,
    "McNiel",
    "#0300b1",
    {
        who: "My love",
        age: 27,
        money: variables.player.money,
        debt: variables.player.debt,
        where: variables.player.where,
    });
player.messages = {
    mes01: [
        {them: {text: "other.messages.player.mes01_01"}},
        {me: {text: "other.messages.player.mes01_02"}},
        {them: {emoji: "other.messages.player.mes01_03"}},
        {me: {emoji: "other.messages.player.mes01_04"}}
    ],
    mes02: [
        {them: {text: "other.messages.player.mes02_01"}},
        {me: {text: "other.messages.player.mes02_02"}},
        {them: {text: "other.messages.player.mes02_03"}},
        {me: {text: "other.messages.player.mes02_04"}},
    ],
    mes03: [
        {me: {text: "other.messages.player.mes03_01"}},
        {me: {image: [images.player.messages, "03"]}},
        {them: {text: "other.messages.player.mes03_03"}},
        {me: {text: "other.messages.player.mes03_04"}},
    ],
    mes04: [
        {them: {text: "other.messages.player.mes04_01"}},
        {me: {text: "other.messages.player.mes04_02"}},
        {them: {text: "other.messages.player.mes04_03"}},
        {them: {text: "other.messages.player.mes04_04"}},
        {me: {text: "other.messages.player.mes04_05"}},
        {them: {text: "other.messages.player.mes04_06"}},
    ],
    mes05: [
        {me: {text: "other.messages.player.mes05_01"}},
        {them: {text: "other.messages.player.mes05_02"}},
        {me: {text: "other.messages.player.mes05_03"}},
        {them: {text: "other.messages.player.mes05_04"}}
    ]
};

const wifeMother = new Man("wifeMother", "Mom", "", "", {who: "❤"});
wifeMother.messages = {mes01: [
    {them: {text: `${wife.name}! When will you come visit us? We all miss you!!!`}},
    {me: {text: `Not now, mom. We are busy. May be next month`}},
    {them: {text: `You always say this!!! But never really do!!!`}},
    {me: {text: `Love you, mom`}},
    {them: {text: `Is that it???? When will you visit us???`}}
]};

const people = {
    player,
    wife,
    father: new Man("father", "Victor", "McNiel", "#004313"),
    mother: new Man("mother", "Mary", "McNiel", "#8e7600"),
    sister: new Man("sister", "Anna", "McNiel", "#ffc563"),
    wifeMother,
    pillsManufacturer: new Man("pillsManufacturer", "Mr. Chain", "", "#6d3180"),
    apartments01Keeper: new Man("apartments01Keeper", "Mr. Erikson", "", "#1ec000"),
    officeWorker: new Man("officeWorker", "Thomas", "", "#3c93ff"),
    officeHead: new Man("officeHead", "Mr. Watson", "", "#5d3b1d")
};

export const currentPlayer = Object.assign(
    Object.create(Object.getPrototypeOf(people[variables.game.currentPlayer])), people[variables.game.currentPlayer]
)
currentPlayer.set = function (who) {
    Object.keys(who).forEach((key) => {
        (key !== "set") && (this[key] = who[key]);
    });
    variables.game.currentPlayer = who.id;
};
currentPlayer.isWife = function () { return this.id === "wife" };
currentPlayer.isPlayer = function () { return this.id === "player" };
currentPlayer.goTo = function (placeID) {
    this.setLocation(placeID);
    setTimeout(() => {jumpTo(links.game.place)}, 20);
};

export default people;

